// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bWdSh__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background: var(--color-paper-2);
  z-index: 1000;
  overflow-y: auto;
  padding-bottom: 6em;
}

.bWdSh__layout a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.bWdSh__layout a:hover {
      opacity: 0.8;
    }

.DarWm__pageHeader {
  display: flex;
  align-items: center;
  gap: 0.8em;
  padding: 1.5em 1.5em 0;
  max-width: 960px;
  margin: 0 auto;
}

.DarWm__pageHeader a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.DarWm__pageHeader h1 {
    margin: 0;
  }

/* Hero */
.jsNQn__hero {
  text-align: center;
  padding: 10vh 1.5em 2em;
  max-width: 640px;
  margin: 0 auto;
}
.jsNQn__hero h2 {
    font-size: 2.5em;
    margin: 0 0 0.3em;
    line-height: 1.1;
  }

.rOYUY__heroSub {
  font-size: 1.15em;
  opacity: 0.85;
}

.rOYUY__heroSub strong {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5em;
  }

/* Pilot callout */
.ge1rX__pilot {
  max-width: 640px;
  margin: 0 auto;
  padding: 1em 1.5em 0;
}

.QtCCp__pilotCard {
  text-align: center;
  padding: 2em 1.5em;
  border-radius: 16px;
  --card-compact-padding-x: 0;
  --card-compact-padding-y: 0;
}

.QtCCp__pilotCard h3 {
    font-size: 1.3em;
    margin: 0.4em 0 0.8em;
    font-weight: 600;
  }

.QtCCp__pilotCard p {
    margin: 0 0 0.8em;
    line-height: 1.5;
  }

.QtCCp__pilotCard p:last-child {
    margin-bottom: 0;
  }

.HvX0P__pilotIcon {
  font-size: 2em;
  color: var(--color-green-1);
}

.qS2up__pilotCta {
  margin-top: 1.4em;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  font-size: 1.5em;
  font-weight: bold;
}

/* Bottom CTA */
.oCc5T__bottomCta {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em 0;
  display: flex;
  justify-content: center;
}

.TXWYB__bottomCtaButton {
  font-size: 1.5em;
  font-weight: bold;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
}

/* Generic content sections */
.D7Sqx__section {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
}
.D7Sqx__section h2 {
    font-size: 1.8em;
    margin: 0 0 0.5em;
  }
.D7Sqx__section p {
    margin: 0 0 0.8em;
    line-height: 1.5;
  }
.D7Sqx__section strong {
    font-weight: bold;
  }

.eAUtf__sectionIcon {
  font-size: 2em;
  color: var(--color-blue-1);
  margin-bottom: 0.3em;
}

.KpKZg__sectionNote {
  font-size: 0.95em;
  opacity: 0.75;
  font-style: italic;
}

/* Feature list */
.qXird__featureList {
  list-style: none;
  padding: 0;
  margin: 0.5em 0 0.8em;
  display: flex;
  flex-direction: column;
  gap: 0.7em;
}
.qXird__featureList li {
    display: flex;
    align-items: flex-start;
    gap: 0.7em;
    line-height: 1.4;
  }

.sMiDT__checkIcon {
  color: var(--color-green-1);
  margin-top: 0.25em;
  flex-shrink: 0;
}

/* Footer */
.dElp8__footer {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
  text-align: center;
  font-size: 0.9em;
  opacity: 0.65;
}
.dElp8__footer p {
    margin: 0 0 0.8em;
  }
`, "",{"version":3,"sources":["webpack://./src/app/routes/ambassadors/AmbassadorsRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AAWrB;;AATE;IACE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAUhB;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX;;AAGF,SAAS;AACT;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAOhB;AALE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,iBAAiB;EACjB,aAAa;AAOf;;AALE;IACE,cAAc;IACd,iBAAiB;IACjB,oBAAoB;EACtB;;AAGF,kBAAkB;AAClB;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;AAgB7B;;AAdE;IACE,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;;AAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,wCAAgC;EAAhC,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AAepB;AAbE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,UAAU;AAQZ;AANE;IACE,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,gBAAgB;EAClB;;AAGF;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AAKf;AAHE;IACE,iBAAiB;EACnB","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  background: var(--color-paper-2);\n  z-index: 1000;\n  overflow-y: auto;\n  padding-bottom: 6em;\n\n  & a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n  padding: 1.5em 1.5em 0;\n  max-width: 960px;\n  margin: 0 auto;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n\n/* Hero */\n.hero {\n  text-align: center;\n  padding: 10vh 1.5em 2em;\n  max-width: 640px;\n  margin: 0 auto;\n\n  & h2 {\n    font-size: 2.5em;\n    margin: 0 0 0.3em;\n    line-height: 1.1;\n  }\n}\n\n.heroSub {\n  font-size: 1.15em;\n  opacity: 0.85;\n\n  & strong {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 0.5em;\n  }\n}\n\n/* Pilot callout */\n.pilot {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 1em 1.5em 0;\n}\n\n.pilotCard {\n  text-align: center;\n  padding: 2em 1.5em;\n  border-radius: 16px;\n  --card-compact-padding-x: 0;\n  --card-compact-padding-y: 0;\n\n  & h3 {\n    font-size: 1.3em;\n    margin: 0.4em 0 0.8em;\n    font-weight: 600;\n  }\n\n  & p {\n    margin: 0 0 0.8em;\n    line-height: 1.5;\n  }\n\n  & p:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.pilotIcon {\n  font-size: 2em;\n  color: var(--color-green-1);\n}\n\n.pilotCta {\n  margin-top: 1.4em;\n  text-decoration: none !important;\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n/* Bottom CTA */\n.bottomCta {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em 0;\n  display: flex;\n  justify-content: center;\n}\n\n.bottomCtaButton {\n  font-size: 1.5em;\n  font-weight: bold;\n  text-decoration: none !important;\n}\n\n/* Generic content sections */\n.section {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n\n  & h2 {\n    font-size: 1.8em;\n    margin: 0 0 0.5em;\n  }\n\n  & p {\n    margin: 0 0 0.8em;\n    line-height: 1.5;\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.sectionIcon {\n  font-size: 2em;\n  color: var(--color-blue-1);\n  margin-bottom: 0.3em;\n}\n\n.sectionNote {\n  font-size: 0.95em;\n  opacity: 0.75;\n  font-style: italic;\n}\n\n/* Feature list */\n.featureList {\n  list-style: none;\n  padding: 0;\n  margin: 0.5em 0 0.8em;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7em;\n\n  & li {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.7em;\n    line-height: 1.4;\n  }\n}\n\n.checkIcon {\n  color: var(--color-green-1);\n  margin-top: 0.25em;\n  flex-shrink: 0;\n}\n\n/* Footer */\n.footer {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n  text-align: center;\n  font-size: 0.9em;\n  opacity: 0.65;\n\n  & p {\n    margin: 0 0 0.8em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `bWdSh__layout`;
export var pageHeader = `DarWm__pageHeader`;
export var hero = `jsNQn__hero`;
export var heroSub = `rOYUY__heroSub`;
export var pilot = `ge1rX__pilot`;
export var pilotCard = `QtCCp__pilotCard`;
export var pilotIcon = `HvX0P__pilotIcon`;
export var pilotCta = `qS2up__pilotCta`;
export var bottomCta = `oCc5T__bottomCta`;
export var bottomCtaButton = `TXWYB__bottomCtaButton`;
export var section = `D7Sqx__section`;
export var sectionIcon = `eAUtf__sectionIcon`;
export var sectionNote = `KpKZg__sectionNote`;
export var featureList = `qXird__featureList`;
export var checkIcon = `sMiDT__checkIcon`;
export var footer = `dElp8__footer`;
export default ___CSS_LOADER_EXPORT___;
